import React from 'react';
import backgroundImage from '../background.webp';
import cardbackground from '../cardbackground.webp'; // Import card background image
import buttonImage from '../buttonimage.webp'; // Add this import
import { supabase } from '../supabaseClient';

export default function OneTimeIssue({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                return;
            }

            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'healingFormulasPage/oneTimeIssue',
                    animated_helper: 'no', // <-- always set to 'no'
                    timestamp: new Date().toISOString(),
                });

            if (progressError) {
                console.error('Error saving progress:', progressError.message);
                alert('Failed to save progress: ' + progressError.message);
                return;
            }

            alert('Progress saved successfully!');
        } catch (err) {
            console.error('Unexpected error saving progress:', err);
            alert('An unexpected error occurred while saving progress.');
        }
    };

    const cardStyle = {
        width: '100%',
        maxWidth: '600px',
        height: 'auto',
        backgroundImage: `url(${cardbackground})`, // Use imported card background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        border: '2px solid black',
        borderRadius: '10px',
        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
        marginBottom: '20px', // Add space between cards
        padding: '20px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    };

    const cardTextStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: '16px',
        fontWeight: 'bold',
        color: 'black',
        marginBottom: '10px',
    };

    return (
        <>
            <style>
                {`
                @media (max-width: 600px) {
                    .oti-btn-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                    }
                    .oti-btn {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 100px !important;
                        padding: 10px 0 !important;
                        font-size: 16px !important;
                    }
                }
                `}
            </style>
            <div
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px',
                }}
            >
                <h2
                    style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '36px',
                        fontWeight: 'bold',
                        color: '#4B5563',
                        textAlign: 'center',
                        marginTop: '16px',
                    }}
                >
                    One Time Issue
                </h2>
                {/* Session Helper Cards Row */}
                <div
                    className="onetimeissue-session-helper-row"
                    style={{
                        display: 'flex',
                        flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '600px',
                        marginBottom: '16px',
                    }}
                >
                    {/* Left Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardbackground})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>• Acknowledge the issue</div>
                            <div>• Validate self on your perspective of it</div>
                            <div>• Accept that this is what you are processing right now</div>
                            <div>• Be Present with how you feel without wishing it was different</div>
                            <div>• Ask yourself what else you need</div>
                            <div>• Come back to center </div>
                        </div>
                    </div>
                    {/* Right Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardbackground})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>1. What is actually the issue here?</div>
                            <div>2. Why do I think and feel about it the way I do?</div>
                            <div>3. Can I accept that this is the experience, or thought, or feeling, I am having?</div>
                            <div>4. Am I being Present with the feelings I have about this?</div>
                            <div>5. Is there some other need I have for myself right now?</div>
                            <div>6. Am I being the version of myself who can handle this?</div>
                        </div>
                    </div>
                </div>
                <div style={cardStyle}>
                    <p style={cardTextStyle}>
                        So, When we go through something difficult to process it can be helpful to have a light house to help us navigate.  This is the light house that I can offer. <br /> Whenever we go through something difficult and we are overwhelmed or confused, or even if we decide something that is not actually true, this can cause us to CREATE a pattern that will loop in our experience until we CAN fully process it.  Meaning, it creates a trigger point that will activate the same energy to play out so we have another chance to process it. <br />  Sometimes these patterns can repeat for years when we do not have the ability to process whatever it is. Each time we come back to the experience, behavior, or feeling we are likely more equipped to handle the experience differently and resolve the pattern. <br /> It is not bad or wrong to have created patterns that repeat in our lives. Sometimes we may be trying to learn something from the experience and having it repeatedly gives us more to consider.  Knowing how these patterns are created allows us to avoid it whenever possible.                      </p>
                    <p style={cardTextStyle}>
                         With this understanding, we can see the importance of processing through and being present with the one-time experience we are having.  Sometimes this can be difficult, and this is a skill we can practice and build over time. Sometimes we could feel stuck and unable to move forward. Stuck is a feeling caused by fear. A decision is the way out.  Let's look at the steps you can use to assist you in processing this experience for yourself.
                    </p>
                </div>
                <div style={cardStyle}>
                    <p style={cardTextStyle}>
                        1. Acknowledge you are experiencing something that might be difficult or uncomfortable for you.
                    </p>
                    <p style={cardTextStyle}>
                        2. Validate that the experience is difficult, overwhelming, or uncomfortable for you and examine the reasons why. You cannot get this wrong. There is no wrong reason to feel how you feel about the experience you are having. This is simply an opportunity for you to understand yourself more.
                    </p>
                    <p style={cardTextStyle}>
                        3. Accept that this is the experience you are having. Even if you do not like it or agree with it, this is the reality. This step is about releasing resistance to what is. This step will immediately offer relief if you have been trying to resist the experience, behavior, or feeling you are having.
                    </p>
                    <p style={cardTextStyle}>
                        4. The last step of the process involves being Present with how you feel about the experience.  Being present means that you are not pushing it away, you are not wishing it was different, no blaming anything or anyone, no thinking about the past of the future.  It's just being with the feeling.  Let the feeling be there.  You can image the feeling is a small child that needs you to watch it.  You can imagine the feeling being in your own heart.  Do what makes sense for you at this step.  The importance is that you are not pushing it away, suppressing, denying, blaming, shaming, projecting, or trying to get rid of the feeling.   This feeling is an energy that will move on it's own when you become the version of yourself that can allow it to move through you.  If you have done all of the steps then you are processing this experience.
                    </p>
                    <p style={cardTextStyle}>
                        5.  After the feelnig moves through and you no longer feel it lingering with you there might be a new point of view to consider about the experience.  You might see things more clearly, or you might just move on to your next experience in life.
                    </p>
                </div>
                <div style={cardStyle}>
                    <p style={cardTextStyle}>
                        Besides taking the steps to move the energy there can be other things you need in order to help you feel regulated and safe.  If there was a distressed child going through something difficult you would likely look to meet their needs, see what would comfort them...a blanket, a hug... a walk.. some reassurance.  Whatever it may be for you, this would be a good time to check in and meet that need for yourself.  
                    </p>
                </div> {/* Third card */}
                <div
                    className="oti-btn-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        marginBottom: '16px',
                    }}
                >
                    <button
                        className="oti-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={goBack}
                    >
                        Back
                    </button>
                    <button
                        className="oti-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={goHome}
                    >
                        Home
                    </button>
                    <button
                        className="oti-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={handleSaveProgress}
                    >
                        Save
                    </button>
                </div>
            </div>
        </>
    );
}
